import React, { useState, useRef, useEffect } from "react";
import {
  FaUser,
  FaSignOutAlt,
  FaChevronDown,
  FaHeadset,
  FaFileAlt,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/context/AuthContext";
import { useTranslation } from "react-i18next";

const LogoutDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const { logout, role } = useAuth();
  const { t } = useTranslation();
  const name = (localStorage.getItem("Name") || "User").replace(/^"|"$/g, "");
  const district = (localStorage.getItem("District") || "").replace(
    /^"|"$/g,
    "",
  );
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const displayGrievanceForm = () => {
    return (
      role === "trainee" && (
        <a
          href="https://forms.office.com/r/Mc5s4vxzPT"
          target="_blank"
          rel="noopener noreferrer"
          className="mx-2 flex items-center justify-between rounded-xl px-4 py-3 transition-colors hover:bg-primary/5 group"
        >
          <div className="flex items-center gap-4">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-100 text-orange-600 transition-all group-hover:bg-orange-500 group-hover:text-white">
              <FaFileAlt size={18} />
            </div>

            <div>
              <p className="text-sm font-semibold text-gray-800">
                {t("traineeDetails.report")}
              </p>

              <p className="text-xs text-gray-500">
                Submit grievance or feedback
              </p>
            </div>
          </div>

          <FaExternalLinkAlt
            size={14}
            className="text-gray-400 transition-colors group-hover:text-primary"
          />
        </a>
      )
    );
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Profile Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 rounded-full border border-gray-200 p-1.5 text-primary transition-all hover:bg-gray-100 group"
      >
        <div className="rounded-full bg-primary/10 p-2 transition-colors group-hover:bg-primary/20">
          <FaUser size={18} />
        </div>

        <FaChevronDown
          size={12}
          className={`mr-1 transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-3 w-80 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl">
          {/* Header */}
          <div className="bg-primary px-6 py-5 text-white">
            <p className="truncate text-xl font-bold uppercase tracking-wide">
              {name}
            </p>

            {district && (
              <p className="mt-1 text-sm text-white/90">District {district}</p>
            )}
          </div>

          {/* Menu */}
          <div className="py-2">
            {/* Support */}
            <a
              href="tel:+917814987433"
              className="mx-2 flex items-center justify-between rounded-xl px-4 py-3 transition-colors hover:bg-primary/5 group"
            >
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary transition-all group-hover:bg-primary group-hover:text-white">
                  <FaHeadset size={18} />
                </div>

                <div>
                  <p className="text-sm font-semibold text-gray-800">Support</p>
                  <p className="text-xs font-medium text-primary">
                    +91 7814987433
                  </p>
                </div>
              </div>
            </a>

            {/* Divider */}
            <div className="my-2 border-t border-gray-100" />
            {/* Grievance Form */}

            {displayGrievanceForm()}
          </div>

          {/* Logout */}
          <div className="border-t border-gray-100 p-3">
            <button
              onClick={() => {
                const role = logout();

                navigate(
                  role === "mcc" ? "/mcc" : role === "admin" ? "/admin" : "/",
                );
              }}
              className="flex w-full items-center justify-center gap-3 rounded-xl bg-red-50 py-3 text-sm font-bold text-red-600 transition-all hover:bg-red-100"
            >
              <FaSignOutAlt size={16} />
              LOGOUT
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoutDropdown;
